import { useState, useEffect } from 'react'
import { getNostrPool } from '../lib/nostrPool'
import { RELAYS } from '../config/constants'
import { Room } from './useNostrRooms'

const pool = getNostrPool()

export function useRoomMetadata(identifier: string) {
    const [room, setRoom] = useState<Room | null>(null)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        if (!identifier) return

        let isMounted = true
        const fetchMetadata = async () => {
            setIsLoading(true)
            try {
                const filters = [
                    {
                        kinds: [39000],
                        '#d': [identifier],
                        '#t': ['mavililer']
                    }
                ]

                const events = await pool.querySync(RELAYS, filters[0])

                if (!isMounted || events.length === 0) {
                    setIsLoading(false)
                    return
                }

                // Use the latest one
                const event = events.sort((a, b) => b.created_at - a.created_at)[0]

                const dTag = event.tags.find(t => t[0] === 'd')?.[1] || ''
                const name = event.tags.find(t => t[0] === 'name')?.[1] || dTag
                const about = event.tags.find(t => t[0] === 'about')?.[1] || ''
                const picture = event.tags.find(t => t[0] === 'picture')?.[1] || ''

                setRoom({
                    id: event.id,
                    identifier: dTag,
                    name,
                    about,
                    picture,
                    pubkey: event.pubkey,
                    created_at: event.created_at
                })
            } catch (error) {
                console.error('Failed to fetch room metadata:', error)
            } finally {
                if (isMounted) setIsLoading(false)
            }
        }

        fetchMetadata()
        return () => { isMounted = false }
    }, [identifier])

    return { room, isLoading }
}
